import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import { AlertStyled, TextStyled } from './AlertCenter.styled';

export const alertPosition = {
  TOP: 'top',
  TOPLEFT: 'top-left',
  TOPRIGHT: 'top-right',
  BOTTOM: 'bottom',
  BOTTOMLEFT: 'bottom-left',
  BOTTOMRIGHT: 'bottom-right',
};

export const alertTypes = ['info', 'error', 'warning', 'success'];

export function AlertComponent({ classNames, id, styles, message }) {
  return (
    <AlertStyled className={classNames} id={id} style={styles}>
      <TextStyled className='s-alert-box-inner' role='alert'>
        {message}
      </TextStyled>
    </AlertStyled>
  );
}

/**
 * **Alert** component is used to communicate relevant information to the user after or before an action is executed.
 */
function AlertCenter({ position, timeout }) {
  return (
    <Alert
      stack={{ limit: 3 }}
      position={position}
      timeout={timeout}
      effect='slide'
      contentTemplate={AlertComponent}
    />
  );
}

export default AlertCenter;

AlertCenter.defaultProps = {
  position: alertPosition.BOTTOMLEFT,
  timeout: 4000,
};

AlertCenter.propTypes = {
  position: PropTypes.oneOf(Object.values(alertPosition)),
  /**
    After this timeout the component will be hidden (miliseconds)
   */
  timeout: PropTypes.number,
};

AlertComponent.propTypes = {
  classNames: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.object,
  message: PropTypes.string,
};
